import { ReactNode, createContext, useContext } from 'react';

const CheckoutExperimentContext = createContext({
  financingUiEnabled: false,
});

const useCheckoutExperiments = () => {
  const context = useContext(CheckoutExperimentContext);
  if (context === undefined) {
    throw new Error(
      'useCheckoutExperiments must be used within a CheckoutExperimentProvider',
    );
  }
  return context;
};

interface CheckoutExperimentsProps {
  children: ReactNode;
  experiments: Record<string, any>;
}

/*
  Provides a component that wraps checkout with experiment details.
  Values for individual experiments can either be specific group names or simple
  boolean values to indicate whether to toggle experiment behavior.
 */
const CheckoutExperiments = ({
  children,
  experiments,
}: CheckoutExperimentsProps) => {
  // Leaving financingUiEnabled here so experiments/values is used.
  // However, this flag is not used anymore and can be deleted when a new
  // experiment is added.
  const values = {
    financingUiEnabled: experiments.financing_ui_enabled || false,
  };

  return (
    <CheckoutExperimentContext.Provider value={values}>
      {children}
    </CheckoutExperimentContext.Provider>
  );
};

export { CheckoutExperiments, useCheckoutExperiments };
